import { Button, Stack, Typography } from '@mui/material';
import { formatMessage } from 'src/i18n/intl';
import { useEffect } from 'react';
import FullPageLayout from 'src/asio-neon-components/Layouts/FullPageLayout';
import Stepper from 'src/asio-neon-components/Stepper/Stepper';
import { useRouting } from 'src/asio-neon-components/Utils';
import ConfigureExternalIdP from 'src/features/authentication-v2/components/ConfigureExternalIdP/ConfigureExternalIdPContainer';
import UsersTable from 'src/features/users-v2/components/NewUsers/NewUsersContainer';
import Locale from 'src/i18n';

const AddExternalIdP = props => {
    const {
        errors,
        onDidMount,
        onAddExternalIdP,
        onAssignUsers,
        isFilled,
        usersSelected,
        onComponentWillUnmount,
        screenKey,
    } = props;

    const { goBack } = useRouting();

    useEffect(() => {
        onDidMount();
        return () => {
            onComponentWillUnmount();
        };
    }, []);

    const steps = [
        {
            title: formatMessage(Locale.authenticationDetails),
            content: <ConfigureExternalIdP screenKey={screenKey} />,
            onNext: onAddExternalIdP,
            proceedDisabled: !isFilled,
        },
        {
            title: formatMessage(Locale.usersList),
            content: (
                <Stack sx={{ height: '100%', width: '100%' }}>
                    <UsersTable embedded shouldNotShowAlert screenKey={screenKey} readOnly={false} />
                </Stack>
            ),
            onNext: onAssignUsers,
            proceedDisabled: !usersSelected,
        },
    ];

    const globalActions = [<Button onClick={goBack}>{formatMessage(Locale.cancel)}</Button>];

    return (
        <FullPageLayout
            PageTitle={<Typography variant="h4">{formatMessage(Locale.addIdPProvider)}</Typography>}
            screenKey={screenKey}>
            <Stepper
                steps={steps}
                errors={errors}
                globalActions={globalActions}
                successScreenProps={{
                    title: formatMessage(Locale.addExternalIdPSuccessTitle),
                }}
                customBack={{ hide: true }}
                customNext={{ label: formatMessage(Locale.saveAndNext) }}
                rootTab="/authentication"
            />
        </FullPageLayout>
    );
};

export default AddExternalIdP;
